import React from 'react';
import classNames from 'classnames';
import { Classes } from '../index';
type Props = { className?: string; children?: React.ReactNode };
export const Note: React.FC<Props> = ({ className, children }) => {
  return <div className={classNames(Classes.NOTE, className)}>{children}</div>;
};
